import classNames from "classnames";
import useTranslate from "hooks/useTranslate";
import Button from "components/atoms/Button";
import { replaceValuesInText } from "utils/replaceValuesInText";
import {
  LoyaltyRewardMiniCardProps,
  LoyaltyRewardMiniCardVariant,
} from "./types";
import { ContentLoyaltyRewardMiniCard } from "./constants";
import "./styles.sass";

const LoyaltyRewardMiniCard = (props: LoyaltyRewardMiniCardProps) => {
  const {
    value,
    variant,
    primaryTitle = false,
    canGet = false,
    image,
    rankName,
    handleClick,
  } = props;
  const t = useTranslate();
  const { title, descriptionActive } = ContentLoyaltyRewardMiniCard[variant];

  const titleClass = classNames(
    "LoyaltyRewardMiniCard__title",
    primaryTitle && "LoyaltyRewardMiniCard__title_primary",
  );

  const imageClass = classNames(
    "LoyaltyRewardMiniCard__image",
    variant === LoyaltyRewardMiniCardVariant.FREE_SPINS &&
      "LoyaltyRewardMiniCard__image_freeSpins",
  );

  return (
    <div className="LoyaltyRewardMiniCard">
      <div className="LoyaltyRewardMiniCard__content">
        <div className="LoyaltyRewardMiniCard__left">
          <div>
            <h3 className={titleClass}>
              {replaceValuesInText(t(title), {
                value,
                countFS: value,
              })}
            </h3>
            <p className="LoyaltyRewardMiniCard__description">
              {canGet
                ? t(descriptionActive)
                : t("loyalty.mini-card.not-available")}
            </p>
            {!canGet && rankName && (
              <span className="LoyaltyRewardMiniCard__descriptionReward">
                {replaceValuesInText(t("loyalty.mini-card.reward-for"), {
                  rankName: "",
                })}
                :{" "}
                {rankName && (
                  <span className="LoyaltyRewardMiniCard__rankName">
                    {rankName}
                  </span>
                )}
              </span>
            )}
          </div>
          {canGet && (
            <Button
              className="LoyaltyRewardMiniCard__button"
              variation="primary"
              label={t("loyalty.get")}
              onClick={handleClick}
            />
          )}
        </div>
        <img src={image} alt="reward" className={imageClass} />
      </div>
    </div>
  );
};

export default LoyaltyRewardMiniCard;
